import { render, staticRenderFns } from "./layoutTop.vue?vue&type=template&id=b7872902&scoped=true&"
import script from "./layoutTop.vue?vue&type=script&lang=js&"
export * from "./layoutTop.vue?vue&type=script&lang=js&"
import style0 from "./layoutTop.vue?vue&type=style&index=0&id=b7872902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7872902",
  null
  
)

export default component.exports